module.exports = __webpack_public_path__ + "img/login-logo-pos.1d836c57.png";